package org.multiplatform.kotfolio.pages.kids

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.silk.components.text.SpanText
import org.jetbrains.compose.web.css.em
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.Ul
import org.multiplatform.kotfolio.layout.BlogLayout
import org.multiplatform.kotfolio.layout.BlogProperties
import org.multiplatform.kotfolio.layout.PageProperties

@Page("flowers")
@Composable
fun KidsSpeechFlowersPage() {
    BlogLayout(
        PageProperties(
            "Flowers",
            "" ),
        BlogProperties("Kids", "Flowers")
    ) {
        Column(
            horizontalAlignment = Alignment.Start
        ) {
            SpanText(
                text = "Rose",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The rose is a beautiful flower. It comes in many colors like red, pink, yellow, and white. Roses have a sweet smell and soft petals (પાંખડી). They grow on bushes (ઝાડીઓ) with green leaves. People love to give roses to each other as a sign of love.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Marigold",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Marigold flowers are bright and cheerful (ખુશખુશાલ), often yellow or orange. They have a strong, pleasant (સુખદ) smell. Marigolds are easy to grow and are popular in gardens. Many people use them to decorate homes and temples. Marigolds are known for their ability to repel some insects (કેટલાક જંતુઓને ભગાડવા માટે).",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Lotus",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "The lotus is a beautiful flower that grows in water. It is the national flower (રાષ્ટ્રીય ફૂલ) of India. Lotus flowers are known for their large, round leaves and petals that can be pink or white. They symbolize (પ્રતીક) purity (શુદ્ધતા), beauty, and knowledge. The lotus is considered a sacred (પવિત્ર) flower and is often seen in temples",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Jasmine",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Jasmine is a beautiful flower with a sweet smell. It is often white or yellow. Jasmine flowers grow on shrubs (ઝાડીઓ) or vines (વેલા). People like to grow jasmine in gardens. The flowers are used to make perfumes and teas.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Sunflower",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Sunflowers are big, bright yellow flowers. They turn their heads to follow the sun as it moves across the sky. Sunflowers grow tall and have lots of seeds in their center.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Tulips",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Tulips are beautiful flowers that bloom in the spring. They have cup-shaped petals and come in many colors like red, yellow, and pink. Tulips are often grown in gardens and are a sign that spring has arrived, according to some online sources.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Water lily",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Water lilies are plants that grow in still or slowly moving water. They like ponds, streams, and the edges of lakes in tropical and mild areas. Their floating leaves are often called lily pads. Frogs like to sit on them.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            SpanText(
                text = "Hibiscus",
                modifier = Modifier.fontSize(FontSize.Large).padding(top = 1.em)
                    .fontWeight(FontWeight.Bold)
            )

            Ul {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "Hibiscus flowers are big and colorful.They have five or more petals.Hibiscus flowers can be red, pink, yellow, or white.They grow in warm, sunny places.Hibiscus flowers are beautiful to look at.",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }

            Ol {
                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "soil: માટી (Best friend of soil is: Earthworms (Makes soil fertile))",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }

                Li(Modifier.padding(topBottom = 0.3.em).toAttrs()) {
                    SpanText(
                        text = "buds: કળીઓ",
                        modifier = Modifier
                            .fontSize(FontSize.Medium)
                    )
                }
            }
        }
    }
}


//What flower caused the Dutch stock market to crash in the 17th century? The flower that caused the Dutch stock market crash (or rather, the first major speculative bubble) in the 17th century was the Tulip, during a craze known as Tulip Mania (Tulipomania), where bulbs of certain varieties became incredibly valuable, with prices soaring before collapsing in February 1637.
//According to a popular English phrase, if roses are red, what colour is the violet flower? Blue